import {
  DELETE_INVOICE_REQ
} from '@/store/constants'

export default {
  name: 'InvoiceMixin',
  data () {
    return {
      invoiceEvents: {
        'edit': (invoice) => {
          this.$router.push({ path: '/invoices/' + invoice.id })
        },
        'showcustomer': (invoice) => {
          if (invoice.relationship_id) {
            return this.$router.push({ path: '/clients/r/' + invoice.relationship_id })
          }
          if (invoice.customer_id) {
            return this.$router.push({ path: '/clients/' + invoice.customer_id })
          }
        },
        'sendtomedicalaid': (invoice) => {
          this.invoice = invoice
          // let client = this.setClientFromId(invoice.customer_id)
          this.launchSendToMedicalAidDialog({
            invoice: invoice,
            withCancel: true
          })
        },
        'send': (invoice) => {
          this.invoice = invoice
          let client = this.setClientFromId(invoice.customer_id)
          this.launchSendInvoiceDialog({
            invoice: invoice,
            client: client,
            withClose: false
          })
        },
        'share': (invoice) => {
          if (!this.invoice && this.invoice) { invoice = this.invoice }

          this.invoice = invoice
          let baseUrl = this.$invoiceguru.baseUrl
          if (baseUrl.endsWith('/')) { baseUrl = baseUrl.substr(0, baseUrl.length - 1) }

          let fName = this.getObjectPath(this.me, 'first_name')
          let lName = this.getObjectPath(this.me, 'last_name')
          let profession = this.getObjectPath(this.me, 'profile.profession.name')
          let fullname = `${fName} ${lName}`
          if (profession) {
            fullname = `${fullname} ${profession}`
          }
          let link = {
            title: 'Your invoice from ' + fullname, // invoice.title,
            description: '',
            url: baseUrl + invoice.get_view_url
          }
          let options = {
            relationshipId: invoice.relationship_id,
            links: [link]
          }
          this.launchShareDialog(options)
        },
        'view': (invoice) => {
          if (invoice && invoice.id) {
            let base = this.$invoiceguru.baseUrl
            let path = invoice.get_view_url
            if (!path) {
              path = '/invoice/view/' + invoice.id + '/?key=' + invoice.password
            }
            let url = base + path
            window.open(url, '_blank')
          }
        },
        'showpaymentdialog': (invoice) => {
          let amount = this.formatCurrency(
            invoice.currency,
            invoice.invoice_amount
          )
          let options = {
            title: `Pay ${amount} with SnapScan`,
            snapUrl: invoice.get_snapscan_url,
            snapImg: invoice.get_snapscan_qr
          }
          this.launchSnapDialog(options)
        },
        // this and showpaymentdialog are the wrong way around
        'addpayment': (invoice) => {
          this.$store.dispatch(
            'SET_SPACE',
            [
              'globalDialog',
              'Payment',
              'Record a payment',
              {
                appointmentIds: invoice.appointments,
                touch: Math.random(),
                withHeader: false
              },
              {},
              this.$vuetify.breakpoint.xs
            ]
          )
        },
        'delete': (invoice) => {
          let doDelete = window.confirm('Are you sure you want to delete this invoice?')
          if (doDelete) {
            this.$invoiceguru
              .resource('invoices')
              .id(DELETE_INVOICE_REQ)
              .delete(invoice.id)
          }
        }
      }
    }
  },
  computed: {
    invoiceActions () {
      return [
        {
          icon: 'edit',
          action: 'edit',
          text: 'Edit'
        },
        {
          icon: 'person',
          action: 'showcustomer',
          text: 'Show client'
        },
        {
          icon: 'share',
          action: 'share',
          text: 'Share'
        },
        {
          icon: 'mail',
          action: 'send',
          text: 'Send'
        },
        {
          icon: 'local_hospital',
          action: 'sendtomedicalaid',
          text: 'Send to medical aid'
        },
        {
          icon: 'open_in_new',
          action: 'view',
          text: 'View'
        },
        // {
        //   icon: 'visibility',
        //   action: 'preview',
        //   text: 'Quick view'
        // },
        {
          icon: 'credit_card',
          action: 'showpaymentdialog',
          text: 'Take payment',
          disableIf: (invoice) => {
            return invoice.status.toLowerCase() === 'paid'
          }
        },
        {
          icon: 'attach_money',
          action: 'addpayment',
          text: 'Add a payment',
          disableIf: (invoice) => {
            return invoice.status.toLowerCase() === 'paid'
          }
        },
        {
          icon: 'delete',
          action: 'delete',
          text: 'Delete'
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/invoice.js